import {Temp} from "../utils/Temp.js";

export class CalendarWidget {

	/**
	 * @param {number} month
	 * @param {number} year
	 * @param {number} firstDayOfWeek - 0=sunday, 1=monday
	 * @param {string} days - 7 chars long string with first-letter for every day of week
	 */
	constructor(month, year, firstDayOfWeek, days) {
		this.month = month;
		this.year = year;
		this.firstDayOfWeek = firstDayOfWeek;
		this.days = days;
		this.listeners = [];
	}

	addDatePickListener(listener) {
		this.listeners.push(listener);
	}

	firePick(year, month, date) {
		const larray = this.listeners;
		setTimeout(function () {
			for (let listener of larray) listener(year, month, date);
		}, 0);
	}

	get ui() {
		if (this.root == null) this.rebuild();
		return this.root;
	}

	rebuild() {
		this.root = Temp.tag('table', {clazz: 'dt-calendar'});
		this.rebuildRoot();
	}

	rebuildRoot() {
		this.root.append(this.generateCalNavigation());
		this.root.append(this.generateCalDaysHeader());
		this.calDaysBody = this.generateCalDaysBody();
		this.root.append(this.calDaysBody);
	}

	generateCalNavigation() {
		const header = $('<thead class="dt-navigation"></thead>');
		const crow = $('<tr></tr>');
		const left = $('<th colspan="1"></th>');
		const center = $('<th colspan="5"></th>');
		const right = $('<th colspan="1"></th>');
		left.css('cursor', 'pointer');
		right.css('cursor', 'pointer');
		left.html(Icon.fi("arrow-left-xs"));
		right.html(Icon.fi("arrow-right-xs"));
		this.monthSelect = this.generateMonthSelect();
		center.append(this.monthSelect);
		crow.append(left);
		crow.append(center);
		crow.append(right);
		header.append(crow);
		// Binding
		left.on('click', this.shiftPrevious.bind(this));
		right.on('click', this.shiftNext.bind(this));
		this.monthSelect.on('change', function(sel) {
			const value = sel.val();
			const slash = value.indexOf('/');
			const m = parseInt(value.substring(0, slash))-1;
			const y = parseInt(value.substring(slash+1));
			this.changeMonthYear(m, y, true);
		}.bind(this, this.monthSelect));

		return header;
	}


	generateMonthSelect() {
		const sel = Temp.select({ clazz:'action', style: 'font-size:12px', tabindex: -1 });
		this.updateMonthSelectOptions(sel);
		/* sel.on('focus', function() {
			this.onFocus();
		}.bind(this));
		sel.on('blur', function() {
			this.onBlur();
		}.bind(this));*/
		return sel;
	}

	updateMonthSelectOptions(select) {
		const items = [];
		let m = this.month;
		let y = this.year;
		m = m - 3;
		if (m < 0) {
			m += 12;
			y--;
		}
		let selMonth;
		const now = new Date();
		select.empty();
		for (let i = 0; i < 20; i++) {
			const op = $('<option></option>');
			let value = (m + 1).toString()+'/'+y;
			let name = value;
			if (m === now.getMonth() && y === now.getFullYear()) name = name + ' •';
			op.html(name);
			op.attr('value', value);
			if (m === this.month && y === this.year) op.attr('selected', 'true');
			select.append(op);
			m++;
			if (m === 12) {
				m = 0;
				y++;
			}
		}
	}

	generateCalDaysHeader() {
		const header = $('<thead class="dt-days"></thead>');
		const row = $('<tr></tr>');
		header.append(row);
		for (let i = 0; i < 7; i++) {
			const dayIdx = (this.firstDayOfWeek+i)%7;
			const dayChar = this.days.charAt(dayIdx);
			const h = $('<th></th>');
			h.text(dayChar);
			row.append(h);
		}
		return header;
	}

	generateCalDaysBody() {
		const cbody = $('<tbody class="dt-calendar-grid"></tbody>');
		this.regenerateCalDaysBody(cbody);
		return cbody;
	}

	regenerateCalDaysBody(cbody) {
		let startDay = new Date();
		startDay.setFullYear(this.year, this.month, 1);
		// Move to the first day of week
		while (startDay.getDay() !== this.firstDayOfWeek) {
			startDay.setDate(startDay.getDate() - 1);
		}
		while (this.isThisMonthOrOlder(startDay)) {
			cbody.append(this.generateCalDayRow(startDay));
		}
	}

	isThisMonthOrOlder(date) {
		if (date.getFullYear() < this.year) return true;
		else if (date.getFullYear() === this.year) return date.getMonth() <= this.month;
		return false;
	}

	shiftPrevious() {
		let m = this.month;
		let y = this.year;
		m--;
		if (m < 0) {
			m = 11;
			y--;
		}
		this.changeMonthYear(m, y, true);
	}

	shiftNext() {
		let m = this.month;
		let y = this.year;
		m++;
		if (m > 11) {
			m = 0;
			y++;
		}
		this.changeMonthYear(m, y, true);
	}

	changeMonthYear(month, year, firePick) {
		this.month = month;
		this.year = year;
		this.calDaysBody.empty();
		this.regenerateCalDaysBody(this.calDaysBody);
		this.updateMonthSelectOptions(this.monthSelect);
		if (firePick) this.firePick(year, month, -1);
	}

	moveToDate(day) {
		this.firePick(day.getFullYear(), day.getMonth(), day.getDate());
	}

	generateCalDayRow(day) {
		const row = $('<tr></tr>');
		const today = new Date();
		for (let i = 0; i < 7; i++) {
			const d = $('<td></td>');
			d.text(day.getDate());
			if (day.getMonth() !== this.month) d.addClass('dt-notThisMonth');
			if (day.getDate() === today.getDate() && day.getMonth() === today.getMonth() && day.getFullYear() === today.getFullYear()) {
				d.addClass("dt-today");
			}
			if (day.getDay() === 0 || day.getDay() === 6) d.addClass("dt-weekend");
			d.on('click', this.moveToDate.bind(this, new Date(day.getTime())));
			row.append(d);
			day.setDate(day.getDate() + 1);
		}
		return row;
	}
}
